// src/pages/Services.jsx
import React from "react";
import { Link } from "react-router-dom";
import UT1 from "../assets/UT probe.png";
import UT from "../assets/UT.png"; 
import PAUT from "../assets/PAUT.png";
import PAUT1 from "../assets/PAUT1.jpg";
import PAUT2 from "../assets/work.png";

import TOFD from "../assets/Inhouse3.png";
import TOFD1 from "../assets/Inhouse8.png";

import MPT1 from "../assets/MPT1.jpg";
import MPT2 from "../assets/MPT2.jpg";

import LPT from "../assets/LPT12.jpg";
import LPT4 from "../assets/LPT14.jpg";






import tofdImg from "../assets/machine.png";
import mptImg from "../assets/machine.png";
import ptImg from "../assets/machine.png";
import heroImg from "../assets/machine.png"
import ServiceCarousel from "../components/ServiceCarousel";
import { Helmet } from "react-helmet-async";

const services = [
  {
    id: "ut",
    title: "Ultrasonic Testing (UT)",
    images: [UT, UT1], // multiple imagesd
    desc: "Ultrasonic Testing (UT) is a high-precision NDT method that uses high-frequency sound waves to detect internal flaws and measure material thickness in pipelines, structures, and engineering components.",
    features: [
      "Detect internal defects accurately",
      "Measure wall thickness",
      "Applicable for pipelines, tanks, and structures",
      "Portable and advanced UT equipment",
    ],
  },
  {
    id: "paut",
    title: "Phased Array Ultrasonic Testing (PAUT)",
    images: [PAUT,PAUT1,PAUT2],
    desc: "PAUT uses multiple ultrasonic elements and electronic time delays to create precise images of welds and components, enabling rapid and accurate flaw detection.",
    features: [
      "High-resolution weld inspections",
      "Rapid scanning of complex geometries",
      "Advanced defect sizing and location",
      "Integration with TOFD for enhanced coverage",
    ],
  },
  {
    id: "tofd",
    title: "Time of Flight Diffraction (TOFD)",
    images: [PAUT,TOFD,TOFD1],
    desc: "TOFD is a highly reliable technique for weld inspections and defect sizing using diffracted ultrasonic signals, providing accurate measurement of crack depth and length.",
    features: [
      "Accurate crack sizing",
      "Minimal operator dependence",
      "High repeatability and reliability",
      "Works well with PAUT combination",
    ],
  },
  {
    id: "mpt",
    title: "Magnetic Particle Testing (MPT)",
    images: [ MPT1, MPT2],
    desc: "MPT is a surface and near-surface defect detection technique for ferromagnetic materials, using magnetic fields and ferrous particles to identify discontinuities.",
    features: [
      "Detect surface and near-surface flaws",
      "Quick and reliable inspections",
      "Applicable for welds, castings, and forgings",
      "Portable and easy to apply on site",
    ],
  },
  {
    id: "pt",
    title: "Liquid Penetrant Testing (PT)",
    images: [LPT,LPT4],
    desc: "PT is a widely used method to detect surface-breaking defects in non-porous materials by using visible or fluorescent dye, ensuring high visibility of flaws.",
    features: [
      "Detect cracks and porosity",
      "Applicable for non-ferrous materials",
      "Easy to apply and interpret results",
      "Highly cost-effective inspection method",
    ],
  },
];

const Services = () => {
  return (
    <>
      <Helmet>

  <title>
    NDT Services | Focus Inspection Technology | PAUT TOFD UT RT MT PT Inspection
  </title>

  <meta
    name="description"
    content="
Focus Inspection Technology provides advanced NDT services including PAUT, TOFD, UT, RT, MT, PT, welding inspection, pipeline inspection, refinery inspection, shipyard inspection and industrial testing worldwide.
"
  />

  <meta
    name="keywords"
    content="
Focus Inspection Technology services,
NDT services,
PAUT,
TOFD,
UT testing,
RT testing,
MT PT testing,
welding inspection,
pipeline inspection,
refinery inspection,
shipyard inspection,
industrial inspection,
ndt company india,
focus ndt services
"
  />

  <link
    rel="canonical"
    href="https://focusinspectiontechnology.com/services"
  />

  <meta
    property="og:title"
    content="NDT Services | Focus Inspection Technology"
  />

  <meta
    property="og:description"
    content="Professional NDT inspection services including PAUT TOFD UT RT MT PT and welding inspection worldwide."
  />

  <meta
    property="og:image"
    content="https://focusinspectiontechnology.com/images/excellence.jpeg"
  />

  <meta
    property="og:url"
    content="https://focusinspectiontechnology.com/services"
  />

  <meta property="og:type" content="website" />

  <meta name="twitter:card" content="summary_large_image" />

  <meta
    name="twitter:title"
    content="Focus Inspection Technology Services"
  />

  <meta
    name="twitter:description"
    content="Advanced NDT inspection services including PAUT TOFD UT RT MT PT worldwide."
  />

  <meta
    name="twitter:image"
    content="https://focusinspectiontechnology.com/images/excellence.jpeg"
  />

</Helmet>
    <div className="bg-gray-50">
      {/* Hero Section */}
  {/* Hero Section */}
<section className="relative w-full h-80 flex items-center justify-center mb-16 overflow-hidden">
  {/* Gradient Background */}
  <div className="absolute inset-0 bg-gradient-to-r from-gray-800 to-blue-900"></div>

  {/* Industrial Pattern Overlay */}
  <svg className="absolute inset-0 w-full h-full opacity-20 animate-pulse" xmlns="http://www.w3.org/2000/svg">
    {/* Hex grid pattern */}
    <defs>
      <pattern id="hexPatternServices" width="60" height="52" patternUnits="userSpaceOnUse" patternTransform="rotate(30)">
        <polygon points="30,0 60,15 60,45 30,60 0,45 0,15" stroke="white" strokeWidth="0.3" fill="none" />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#hexPatternServices)" />

    {/* Diagonal lines */}
    <line x1="0" y1="0" x2="800" y2="800" stroke="white" strokeWidth="0.2" />
    <line x1="800" y1="0" x2="0" y2="800" stroke="white" strokeWidth="0.2" />

    {/* Gear-like circles */}
    <circle cx="150" cy="100" r="80" stroke="white" strokeWidth="0.5" fill="none" />
    <circle cx="600" cy="50" r="120" stroke="white" strokeWidth="0.5" fill="none" />
  </svg>

  {/* Hero Text */}
  <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
    <h1 className="text-4xl md:text-5xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-gray-300 via-white to-gray-400 drop-shadow-lg">
      Our Services
    </h1>
    <p className="text-lg md:text-xl max-w-2xl mx-auto text-white">
      FOCUS Inspection Technology provides advanced Non-Destructive Testing (NDT) services to ensure the integrity and reliability of pipelines, engineering fabrications, and structural components.
    </p>
  </div>
</section>


      {/* Services Details */}
      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-20 space-y-24">
{services.map((service, idx) => (
  <div
    key={service.id}
    className={`flex flex-col lg:flex-row items-center gap-12 ${
      idx % 2 !== 0 ? "lg:flex-row-reverse" : ""
    }`}
  >
    {/* Interactive Carousel */}
    <ServiceCarousel service={service} />

    {/* Text */}
    <div className="lg:w-1/2 space-y-6 text-center lg:text-left">
      <h2 className="text-3xl font-bold text-blue-700">{service.title}</h2>
      <p className="text-gray-700 text-lg leading-relaxed">{service.desc}</p>
      <ul className="list-disc pl-5 space-y-2 text-gray-600">
        {service.features.map((feature, idx) => (
          <li key={idx}>{feature}</li>
        ))}
      </ul>
      <Link
        to="/contact"
        className="inline-block mt-4 px-6 py-2 bg-blue-700 text-white rounded-lg hover:bg-orange-500 transition-all transform hover:scale-105 hover:shadow-lg"
      >
        Request Service
      </Link>
    </div>
  </div>
))}


      </section>
    </div>
    </>
  );
};

export default Services;
